import script from "./pollTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./pollTemp.vue?vue&type=script&setup=true&lang=js"

import "./pollTemp.vue?vue&type=style&index=0&id=7976b3b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7976b3b7"]])

export default __exports__